import TopTagsReducer from './TopTagsReducer';

export default from './TopTagsContainer';
export const TopTagsReducers = {
  TopTagsReducer,
};
